import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errText } from "../lib/api";

export const FollowMilestone = ({ order, title }) => {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  useEffect(() => setDone(false), [order]);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post(`/plans/${order}/follow`, { email });
      setDone(true);
      setEmail("");
      toast.success(`You are following Step ${order}`);
    } catch (err) {
      toast.error(errText(err));
    } finally {
      setBusy(false);
    }
  };

  if (done)
    return (
      <p
        className="border-l-2 border-ochre bg-[#0b0b0b] px-5 py-4 text-sm text-zinc-300"
        data-testid={`follow-done-${order}`}
      >
        You are following <span className="text-white">{title}</span>. We will email you whenever this step moves.
      </p>
    );

  return (
    <form
      onSubmit={submit}
      className="flex flex-col gap-3 border-l-2 border-maasai bg-[#0b0b0b] p-5 sm:flex-row sm:items-center"
      data-testid={`follow-form-${order}`}
    >
      <span className="text-[0.6rem] font-bold uppercase tracking-[0.2em] text-ochre sm:w-40">
        Follow this step
      </span>
      <input
        type="email"
        required
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="you@email.com"
        data-testid={`follow-email-${order}`}
        className="min-w-0 flex-1 border border-white/15 bg-black px-4 py-3 text-sm text-white placeholder:text-zinc-400 focus:border-ochre focus:outline-none"
      />
      <button
        type="submit"
        disabled={busy}
        data-testid={`follow-submit-${order}`}
        className="bg-maasai px-6 py-3 text-[0.62rem] font-bold uppercase tracking-[0.18em] text-white transition-colors hover:bg-white hover:text-black disabled:opacity-50"
      >
        {busy ? "Saving" : "Email me updates"}
      </button>
    </form>
  );
};
